<template>
  <Dialog
    v-model:visible="isVisible"
    :header="title"
    :modal="true"
    :closable="true"
    :draggable="false"
    class="w-11/12 md:w-96"
    @update:visible="onVisibleChange">

    <div class="flex flex-col gap-4 p-4">
      <p class="text-sm text-gray-700">{{ message }}</p>

      <div v-if="automationEnabled" class="flex items-center justify-between bg-gray-50 rounded-lg p-3">
        <label for="cancel-send-sms-toggle" class="text-sm text-gray-800">שליחת הודעת ביטול ללקוח</label>
        <ToggleSwitch v-model="sendSms" inputId="cancel-send-sms-toggle" />
      </div>

      <!-- Optional, never blocks the cancellation. Saved on the appointment so the
           reason is still there months later. -->
      <div class="flex flex-col gap-1.5">
        <label for="cancel-reason" class="text-sm text-gray-800">סיבת הביטול <span class="text-gray-400">(אופציונלי)</span></label>
        <Textarea
          id="cancel-reason"
          v-model="reason"
          rows="2"
          :maxlength="REASON_MAX_LENGTH"
          class="w-full text-sm"
          placeholder="לדוגמה: הלקוח/ה ביקש/ה לדחות, מחלה, חופשה"
          dir="rtl" />
      </div>

      <div class="flex gap-3">
        <Button label="לא" class="flex-1" text @click="handleClose" />
        <Button label="כן" class="flex-1" @click="handleConfirm" />
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import ToggleSwitch from 'primevue/toggleswitch';

/** Kept short — this is a note for the business, not a message to the customer. */
const REASON_MAX_LENGTH = 200;

const props = withDefaults(defineProps<{
  visible: boolean;
  title?: string;
  message?: string;
  defaultSendSms?: boolean;
  /** When false, the "send cancellation message" toggle is hidden and no message is sent. */
  automationEnabled?: boolean;
}>(), {
  title: 'רק מוודאים',
  message: 'האם לבטל את התור? לא ניתן לבטל פעולה זו',
  defaultSendSms: true,
  automationEnabled: true,
});

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void;
  (e: 'confirm', sendSms: boolean, reason?: string): void;
}>();

const isVisible = ref(props.visible);
const sendSms = ref(props.defaultSendSms);
const reason = ref('');

watch(() => props.visible, (newVal) => {
  isVisible.value = newVal;
  if (newVal) {
    sendSms.value = props.defaultSendSms;
    reason.value = '';
  }
});

function handleConfirm() {
  emit('confirm', props.automationEnabled && sendSms.value, reason.value.trim() || undefined);
  emit('update:visible', false);
}

function handleClose() {
  emit('update:visible', false);
}

function onVisibleChange(visible: boolean) {
  if (!visible) emit('update:visible', false);
}
</script>
